export default "__VITE_ASSET__cwNgBZvH__"